import * as React from 'react';

export const CenteredContent: React.FC<React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
>> = (props) => (
    <div
        {...props}
        style={{
            flex: '1 1 100%',
            justifyContent: 'center',
            height: '80vh',
            ...(props.style || {}),
        }}
    >
        {props.children}
    </div>
);
